import React, { useState } from 'react'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { ImageIcon } from 'lucide-react'

/** ERP schematic thumbnail; click opens the full image (doesn't open the row). */
export function ErpImageThumb({
  thumbUrl,
  fullUrl,
  title,
  size = 72,
}: {
  thumbUrl?: string | null
  fullUrl?: string | null
  title: string
  size?: number
}) {
  const [open, setOpen] = useState(false)
  const src = thumbUrl || fullUrl

  if (!src) {
    return (
      <div
        className="flex items-center justify-center rounded border border-dashed text-muted-foreground"
        style={{ width: size, height: size }}
        title="No ERP image"
      >
        <ImageIcon className="h-4 w-4" />
      </div>
    )
  }

  // React events bubble through the dialog's portal, so stop them here or a
  // click inside the zoom dialog would also open the table row.
  return (
    <span className="inline-block" onClick={e => e.stopPropagation()}>
      <button
        type="button"
        className="overflow-hidden rounded border bg-white hover:ring-2 hover:ring-primary/50"
        style={{ width: size, height: size }}
        onClick={() => setOpen(true)}
        title="Open ERP image"
      >
        <img
          src={src}
          alt={title}
          loading="lazy"
          className="h-full w-full object-contain"
        />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl">
          <DialogTitle className="font-mono text-sm">{title}</DialogTitle>
          <img
            src={fullUrl || src}
            alt={title}
            className="max-h-[75vh] w-full object-contain"
          />
        </DialogContent>
      </Dialog>
    </span>
  )
}
